import React from 'react';

import {
  AddressIconSvg,
  AlcoholSvg,
  AlertTriangleSvg,
  ArrowDownBlackIconSvg,
  BinIconSvg,
  BudgetSvg,
  CalSvg,
  CantonsIconSvg,
  CartSvg,
  CheckSvg,
  ChevDownSvg,
  ChevUpSvg,
  ChurchSvg,
  CloseRedSvg,
  CloseSvg,
  CopySvg,
  DownloadSvg,
  EboardSvg,
  EditOutlineSvg,
  ElevatorPanelSvg,
  EpanelSvg,
  EroticaSvg,
  ExportSvg,
  EyeOffSvg,
  EyeSvg,
  F4Svg,
  F12LRSvg,
  F12LSvg,
  F12Svg,
  F24Svg,
  F200LRSvg,
  F200LSvg,
  F200Svg,
  GreenCheckSvg,
  GreenCheckV2Svg,
  HaengekartonMitDispenserSvg,
  HaengekartonOhneDispenserSvg,
  HandelSvg,
  HotelSvg,
  IconArrowSvg,
  IconCalendarSvg,
  IconCheckmarkSvg,
  IconCloseSvg,
  IconCloseV2Svg,
  IconSearchSvg,
  IDsIconSvg,
  ImportIconSvg,
  InfoIconSvg,
  ListIconSvg,
  LogoSvg,
  MapIconSvg,
  PlacesIconSvg,
  PlusSvg,
  PoliticsSvg,
  RadiusIconSvg,
  RailPosterMidiSvg,
  RailPosterSvg,
  RefreshSvg,
  RefreshWhiteSvg,
  ShareSvg,
  TabacoSvg,
  TargetSvg,
  TimeSvg,
  TMSSvg,
  TRASvg,
  TrafficIconSvg,
  TrashSvg,
  WerbeflachenOhneSvg,
  WhiteCartSvg,
  WhiteEditOutlineSvg,
  WhiteExportSvg,
  WhiteInfoSvg,
  WhiteLogoSvg,
  WhitePlusSvg,
  WhiteSearchSvg,
  WhiteTrashSvg,
  ZipIconSvg,
} from './sourceIcons';

const makeIcon = (svg: string, props?: any) => {
  return <img src={svg} alt={String(svg)} {...props} />;
};
export const GreenCheckIcon = (props?: any) => makeIcon(GreenCheckSvg, props);
export const GreenCheckV2Icon = (props?: any) => makeIcon(GreenCheckV2Svg, props);
export const WhiteSearchIcon = (props?: any) => makeIcon(WhiteSearchSvg, props);
export const WhiteCartIcon = (props?: any) => makeIcon(WhiteCartSvg, props);
export const TrashIcon = (props?: any) => makeIcon(TrashSvg, props);
export const ShareIcon = (props?: any) => makeIcon(ShareSvg, props);
export const DownloadIcon = (props?: any) => makeIcon(DownloadSvg, props);
export const IconCheckmark = (props?: any) => makeIcon(IconCheckmarkSvg, props);
export const WhiteLogo = (props?: any) => makeIcon(WhiteLogoSvg, props);
export const Logo = (props?: any) => makeIcon(LogoSvg, props);
export const IconCalendar = (props?: any) => makeIcon(IconCalendarSvg, props);
export const IconSearch = (props?: any) => makeIcon(IconSearchSvg, props);
export const IconClose = (props?: any) => makeIcon(IconCloseSvg, props);
export const CloseRedIcon = (props?: any) => makeIcon(CloseRedSvg, props);
export const IconArrow = (props?: any) => makeIcon(IconArrowSvg, props);
export const InfoIcon = (props?: any) => makeIcon(InfoIconSvg, props);
export const IconCloseV2 = (props?: any) => makeIcon(IconCloseV2Svg, props);
export const BinIcon = (props?: any) => makeIcon(BinIconSvg, props);
export const AddressIcon = (props?: any) => makeIcon(AddressIconSvg, props);
export const PlacesIcon = (props?: any) => makeIcon(PlacesIconSvg, props);
export const CantonsIcon = (props?: any) => makeIcon(CantonsIconSvg, props);
export const TrafficIcon = (props?: any) => makeIcon(TrafficIconSvg, props);
export const IDsIcon = (props?: any) => makeIcon(IDsIconSvg, props);
export const ZipIcon = (props?: any) => makeIcon(ZipIconSvg, props);
export const ImportIcon = (props?: any) => makeIcon(ImportIconSvg, props);
export const ArrowDownBlackIcon = (props?: any) => makeIcon(ArrowDownBlackIconSvg, props);
export const RadiusIcon = (props?: any) => makeIcon(RadiusIconSvg, props);
export const ListIcon = (props?: any) => makeIcon(ListIconSvg, props);
export const MapIcon = (props?: any) => makeIcon(MapIconSvg, props);
export const ChevUpIcon = (props?: any) => makeIcon(ChevUpSvg, props);
export const ChevDownIcon = (props?: any) => makeIcon(ChevDownSvg, props);
export const PlusIcon = (props?: any) => makeIcon(PlusSvg, props);
export const EditOutlineIcon = (props?: any) => makeIcon(EditOutlineSvg, props);
export const WhiteEditOutlineIcon = (props?: any) => makeIcon(WhiteEditOutlineSvg, props);
export const RefreshIcon = (props?: any) => makeIcon(RefreshSvg, props);
export const RefreshWhiteIcon = (props?: any) => makeIcon(RefreshWhiteSvg, props);
export const CheckIcon = (props?: any) => makeIcon(CheckSvg, props);
export const CartIcon = (props?: any) => makeIcon(CartSvg, props);
export const F12Icon = (props?: any) => makeIcon(F12Svg, props);
export const F12LIcon = (props?: any) => makeIcon(F12LSvg, props);
export const F12LRIcon = (props?: any) => makeIcon(F12LRSvg, props);
export const F200Icon = (props?: any) => makeIcon(F200Svg, props);
export const F200LIcon = (props?: any) => makeIcon(F200LSvg, props);
export const F200LRIcon = (props?: any) => makeIcon(F200LRSvg, props);
export const F4Icon = (props?: any) => makeIcon(F4Svg, props);
export const F24Icon = (props?: any) => makeIcon(F24Svg, props);
export const HaengekartonMitDispenserIcon = (props?: any) => makeIcon(HaengekartonMitDispenserSvg, props);
export const HaengekartonOhneDispenserIcon = (props?: any) => makeIcon(HaengekartonOhneDispenserSvg, props);
export const RailPosterIcon = (props?: any) => makeIcon(RailPosterSvg, props);
export const RailPosterMidiIcon = (props?: any) => makeIcon(RailPosterMidiSvg, props);
export const EpanelIcon = (props?: any) => makeIcon(EpanelSvg, props);
export const EboardIcon = (props?: any) => makeIcon(EboardSvg, props);
export const TMSIcon = (props?: any) => makeIcon(TMSSvg, props);
export const TRAIcon = (props?: any) => makeIcon(TRASvg, props);
export const AlcoholIcon = (props?: any) => makeIcon(AlcoholSvg, props);
export const ChurchIcon = (props?: any) => makeIcon(ChurchSvg, props);
export const EroticaIcon = (props?: any) => makeIcon(EroticaSvg, props);
export const HandelIcon = (props?: any) => makeIcon(HandelSvg, props);
export const PoliticsIcon = (props?: any) => makeIcon(PoliticsSvg, props);
export const TabacoIcon = (props?: any) => makeIcon(TabacoSvg, props);
export const HotelIcon = (props?: any) => makeIcon(HotelSvg, props);
export const WerbeflachenOhneIcon = (props?: any) => makeIcon(WerbeflachenOhneSvg, props);
export const ElevatorPanelIcon = (props?: any) => makeIcon(ElevatorPanelSvg, props);
export const CloseIcon = (props?: any) => makeIcon(CloseSvg, props);
export const BudgetIcon = (props?: any) => makeIcon(BudgetSvg, props);
export const CalIcon = (props?: any) => makeIcon(CalSvg, props);
export const TargetIcon = (props?: any) => makeIcon(TargetSvg, props);
export const TimeIcon = (props?: any) => makeIcon(TimeSvg, props);
export const AlertTriangleIcon = (props?: any) => makeIcon(AlertTriangleSvg, props);
export const WhitePlusIcon = (props?: any) => makeIcon(WhitePlusSvg, props);
export const WhiteTrashIcon = (props?: any) => makeIcon(WhiteTrashSvg, props);
export const WhiteInfoIcon = (props?: any) => makeIcon(WhiteInfoSvg, props);
export const EyeIcon = (props?: any) => makeIcon(EyeSvg, props);
export const EyeOffIcon = (props?: any) => makeIcon(EyeOffSvg, props);
export const ExportIcon = (props?: any) => makeIcon(ExportSvg, props);
export const WhiteExportIcon = (props?: any) => makeIcon(WhiteExportSvg, props);
export const CopyIcon = (props?: any) => makeIcon(CopySvg, props);
export const productIcons = {
  F4: <F4Icon />,
  F4C: <F4Icon />,
  F4S: <F4Icon />,
  F4M: <F4Icon />,
  F4L: <F4Icon />,
  F4ST: <F4Icon />,
  F12: <F12Icon />,
  F12L: <F12LIcon />,
  F12LR: <F12LRIcon />,
  F12P: <F12Icon />,
  F12ST: <F12Icon />,
  F200: <F200Icon />,
  F200L: <F200LIcon />,
  F200LR: <F200LRIcon />,
  F200LS: <F200Icon />,
  F200P: <F200Icon />,
  F24: <F24Icon />,
  F24L: <F24Icon />,
  'Netze F12': <F12Icon />,
  'Netze F200': <F200Icon />,
  'Netze F24': <F24Icon />,
  'Netze F4': <F4Icon />,
  HC: <HaengekartonOhneDispenserIcon />,
  HCD: <HaengekartonMitDispenserIcon />,
  RP: <RailPosterIcon />,
  RPM: <RailPosterMidiIcon />,
  SCR: <EpanelIcon />,
  EBO: <EboardIcon />,
  BOA: <EboardIcon />,
  TMS: <TMSIcon />,
  TRA: <TRAIcon />,
  SCREL: <ElevatorPanelIcon />,
};

export const getProductIcon = (product) => {
  if (product.attributeshortcuts) {
    if (Object.keys(productIcons).indexOf(product.formatcode + product.attributeshortcuts) !== -1) {
      return productIcons[product.formatcode + product.attributeshortcuts];
    }
  }

  if (!productIcons[product.formatcode]) {
    console.log('No icon for product', product.formatcode);
  }

  return productIcons[product.formatcode];
};

export const industryIcons = {
  politics: <PoliticsIcon />,
  alcohol: <AlcoholIcon />,
  church: <ChurchIcon />,
  erotica: <EroticaIcon />,
  handel: <HandelIcon />,
  tabaco: <TabacoIcon />,
  others: <WerbeflachenOhneIcon />,
  hotel: <HotelIcon />,
};

export const searchGroups = {
  place: <PlacesIcon />,
  address: <AddressIcon />,
  canton: <CantonsIcon />,
  trafficcomp: <TrafficIcon />,
  ids: <IDsIcon />,
  zip: <ZipIcon />,
};
